import { FC, useMemo, useState } from 'react';
import { Button, Grid, Typography } from '@material-ui/core';
import clsx from 'clsx';
import { isEmpty } from 'lodash';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { CurrentUserReducer, RootReducer, StreamingReducer } from '../../../../models/Redux';
import { useStyles } from './styles';
import ViewerWaitingItem from './parts/ViewerWaiting';
import { ViewerState } from '../../../../models/StreamingState';
import QueueDialog from './parts/QueueDialog';

interface RaiseHandQueueProps {
    mobileLayout?: boolean;
    onDisplayModal?: () => void;
}

const RaiseHandQueue: FC<RaiseHandQueueProps> = ({ mobileLayout, onDisplayModal }) => {
    const classes = useStyles();
    const { t } = useTranslation();
    const [openDialog, setOpenDialog] = useState<boolean>(false);

    const {
        user: { user_ide: userIde },
    } = useSelector<RootReducer, CurrentUserReducer>(state => state.currentUser);

    const {
        eventData: {
            user: { user_ide: influencerUserIde },
        },
        streamingState: {
            // @ts-ignore
            current_state: { raised_hands: raiseHandQueue, viewers },
        },
    } = useSelector<RootReducer, StreamingReducer>(state => state.streaming);

    const isEventInfluencer = useMemo(() => influencerUserIde === userIde, [influencerUserIde, userIde]);

    const renderQueue = () => {
        return !isEmpty(raiseHandQueue) && isEventInfluencer;
    };

    if (!renderQueue()) {
        return null;
    }

    return (
        <Grid container xs={12} justify="center" alignContent="center" alignItems="center" direction="row">
            <QueueDialog
                open={openDialog}
                onDismiss={() => {
                    setOpenDialog(false);
                }}
            />
            <Grid
                container
                item
                xs={12}
                direction="row"
                className={clsx(classes.container, mobileLayout ? classes.mobileContainer : '')}
            >
                <Button
                    fullWidth
                    className={classes.button}
                    onClick={() => {
                        onDisplayModal?.();
                        setOpenDialog(true);
                    }}
                >
                    <Grid
                        xs={12}
                        container
                        justify="flex-start"
                        alignContent="center"
                        alignItems="center"
                        direction="row"
                    >
                        <Grid
                            container
                            item
                            xs={12}
                            justify="flex-start"
                            alignContent="center"
                            alignItems="center"
                            direction="row"
                        >
                            {viewers
                                .filter((viewer: ViewerState) =>
                                    raiseHandQueue.find(
                                        (vWaiting: ViewerState) => vWaiting.username === viewer.username,
                                    ),
                                )
                                .slice(-3)
                                .map((viewerWaiting: ViewerState, index: number) => {
                                    return (
                                        <ViewerWaitingItem
                                            key={index}
                                            index={index}
                                            avatar={viewerWaiting.user_avatar}
                                            username={viewerWaiting.username}
                                        />
                                    );
                                })}
                            <Typography className={classes.text}>{t('Viewers waiting')}</Typography>
                        </Grid>
                    </Grid>
                </Button>
            </Grid>
        </Grid>
    );
};

export default RaiseHandQueue;
